import React, { useState, useCallback } from 'react';
import { track } from '../../utils/analytics';

// Grid / list switch for the collection pages (Playlists, Likes, Favourite
// Artists), like Finder's view buttons. Device-scoped like the theme: the
// choice is remembered per page in localStorage, never synced.
const KEY = (page) => `mixgoat-view:${page}`;

export function readViewMode(page, fallback = 'grid') {
    try {
        const v = localStorage.getItem(KEY(page));
        return v === 'grid' || v === 'list' ? v : fallback;
    } catch (e) { return fallback; }
}

export function useViewMode(page, fallback = 'grid') {
    const [mode, setMode] = useState(() => readViewMode(page, fallback));
    const change = useCallback((next) => {
        if (next !== 'grid' && next !== 'list') return;
        setMode((prev) => {
            if (prev === next) return prev;
            try { localStorage.setItem(KEY(page), next); } catch (e) { /* ignore */ }
            track('view_mode_changed', { page, mode: next });
            return next;
        });
    }, [page]);
    return [mode, change];
}

const GridIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" />
        <rect x="3" y="14" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" />
    </svg>
);
const ListIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <line x1="8" y1="6" x2="21" y2="6" /><line x1="8" y1="12" x2="21" y2="12" /><line x1="8" y1="18" x2="21" y2="18" />
        <circle cx="4" cy="6" r="1" fill="currentColor" /><circle cx="4" cy="12" r="1" fill="currentColor" /><circle cx="4" cy="18" r="1" fill="currentColor" />
    </svg>
);

export default function ViewToggle({ mode, onChange, gridTitle = 'Grid view', listTitle = 'List view' }) {
    return (
        <div className="v2-view-toggle" role="group" aria-label="View">
            <button type="button" className={`v2-view-btn${mode === 'grid' ? ' on' : ''}`} onClick={() => onChange('grid')} title={gridTitle} aria-pressed={mode === 'grid'}><GridIcon /></button>
            <button type="button" className={`v2-view-btn${mode === 'list' ? ' on' : ''}`} onClick={() => onChange('list')} title={listTitle} aria-pressed={mode === 'list'}><ListIcon /></button>
        </div>
    );
}
